
import React from "react";
import { Zap } from "lucide-react";

interface GerarJogosHeaderProps {
  isFederalLottery: boolean;
}

const GerarJogosHeader: React.FC<GerarJogosHeaderProps> = ({ isFederalLottery }) => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className={`p-3 rounded-xl shadow-lg transition-all duration-300 ${
          isFederalLottery 
            ? 'bg-gradient-to-r from-gold-600 to-yellow-600 shadow-gold-500/50' 
            : 'bg-gradient-to-r from-purple-500 to-blue-500'
        }`}>
          <Zap className="w-8 h-8 text-white" />
        </div>
        <h1 className={`text-3xl md:text-4xl lg:text-5xl font-bold transition-all duration-300 ${
          isFederalLottery 
            ? 'text-gold-300 drop-shadow-lg' 
            : 'bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent'
        }`}>
          IA PALPITE GURU - JOGO DO BICHO
        </h1>
      </div>
      <div className="mb-4">
        <h2 className={`text-xl md:text-2xl font-semibold ${
          isFederalLottery ? 'text-gold-200' : 'text-gray-600 dark:text-gray-300'
        }`}>
          🎯 Inteligência Artificial Especializada
        </h2>
        <p className={`text-lg mt-2 ${
          isFederalLottery ? 'text-gold-100' : 'text-gray-500 dark:text-gray-400'
        }`}>
          Algoritmos avançados para gerar os melhores palpites
        </p>
      </div>
      {isFederalLottery && (
        <div className="bg-gradient-to-r from-gold-600/40 to-yellow-600/40 border-2 border-gold-300 rounded-xl p-6 mb-6 backdrop-blur-sm shadow-2xl">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="text-2xl">⭐</span>
            <p className="text-gold-100 font-bold text-lg">
              EXPERIÊNCIA FEDERAL PREMIUM ATIVADA
            </p>
            <span className="text-2xl">⭐</span>
          </div>
          <p className="text-gold-200 text-sm">
            Algoritmos especializados para loterias federais em funcionamento
          </p>
        </div>
      )}
    </div>
  );
};

export default GerarJogosHeader;
